/**
* The status of a Pipeline.
*/
export const enum PipelineStatus {
  Completed = 'completed',
  Canceled = 'canceled',
  Rejected = 'rejected',
  Running = 'running'
}
